import { SignerDto, CreateSignerDto, UpdateSignerDto } from '@sr/dto';
import { DownloadFileDto } from '@sr/dto';
import { FormTools } from '../../../utils/form-tools';
import { FormikErrors } from 'formik';

export interface FormData {
  legalEntityId: number;
  titleForm1: string;
  titleForm2: string;
  titleForm3: string;
  positionForm1: string;
  positionForm2: string;
  positionForm3: string;
  basedOn: string;
  signature: DownloadFileDto[],
}


export const formTools: FormTools<SignerDto, CreateSignerDto, UpdateSignerDto, FormData> = {
  toCreateDto: (formData) => ({
    legalEntityId: formData.legalEntityId,
    titleForm1: formData.titleForm1,
    titleForm2: formData.titleForm2,
    titleForm3: formData.titleForm3,
    positionForm1: formData.positionForm1,
    positionForm2: formData.positionForm2,
    positionForm3: formData.positionForm3,
    basedOn: formData.basedOn,
    signature: formData.signature.length ? formData.signature[0] : null
  }),

  toUpdateDto: (id, formData): UpdateSignerDto => ({
    id,
    legalEntityId: formData.legalEntityId,
    titleForm1: formData.titleForm1,
    titleForm2: formData.titleForm2,
    titleForm3: formData.titleForm3,
    positionForm1: formData.positionForm1,
    positionForm2: formData.positionForm2,
    positionForm3: formData.positionForm3,
    basedOn: formData.basedOn,
    signature: formData.signature.length ? formData.signature[0] : null
  }),

  fromDto: (dto): FormData => ({
    legalEntityId: dto.legalEntityId,
    titleForm1: dto.titleForm1,
    titleForm2: dto.titleForm2,
    titleForm3: dto.titleForm3,
    positionForm1: dto.positionForm1,
    positionForm2: dto.positionForm2,
    positionForm3: dto.positionForm3,
    basedOn: dto.basedOn,
    signature: dto.signature ? [dto.signature] : []
  }),

  validate: (values: FormData): FormikErrors<FormData> => {
    const errors: ValidationData = {};

    const requiredMsg = 'Поле обязательно';
    if (!values.titleForm1) errors.titleForm1 = requiredMsg;

    if (!values.basedOn) errors.basedOn = requiredMsg;

    return errors;
  },
  emptyValues: () => ({
    legalEntityId: NaN,
    titleForm1: '',
    titleForm2: '',
    titleForm3: '',
    positionForm1: '',
    positionForm2: '',
    positionForm3: '',
    basedOn: '',
    signature: []

  })
};

type ValidationData = Partial<Record<keyof FormData, string>>;

export const validate = (values: FormData) => {
  const errors: ValidationData = {};

  const requiredMsg = 'Поле обязательно';
  if (!values.titleForm1) errors.titleForm1 = requiredMsg;

  if (!values.basedOn) errors.basedOn = requiredMsg;

  return errors;
};
